import { get } from "../helpers/request";
import { components } from "./api";

export const getGlobalInfo = (): Promise<components["schemas"]["GlobalInfo"]> => {
  return get<components["schemas"]["GlobalInfo"]>(`/globalInfo`);
};
